<div>
    <form nz-form #taskSbtaskPage="ngForm">
        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Category</nz-form-label>

                    <nz-form-control>
                        <nz-select name="category" nzShowSearch nzAllowClear nzPlaceHolder="Select a Category"
                            [(ngModel)]="data.TASK_CATEGORY_ID">
                            <nz-option *ngFor="let category of categoryList" [nzValue]="category.ID"
                                [nzLabel]="category.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="6"></div>

            <div nz-col nzSpan="6"></div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Feature</nz-form-label>

                    <nz-form-control>
                        <nz-select name="feature" nzShowSearch nzAllowClear nzPlaceHolder="Select a Feature"
                            [(ngModel)]="data.FEATURE_ID">
                            <nz-option *ngFor="let feature of featureList" [nzValue]="feature.ID"
                                [nzLabel]="feature.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzNoColon>Parent Task</nz-form-label>

                    <nz-form-control>
                        <nz-select name="parentTask" nzShowSearch nzAllowClear nzPlaceHolder="Select a Parent Task"
                            [(ngModel)]="data.PARENT_ID">
                            <nz-option *ngFor="let task of parentTaskList" [nzValue]="task.ID" [nzLabel]="task.NAME">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Name</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Task/ Subtask Name is Required">
                        <input nz-input name="name" type="text" placeHolder="Enter a Task/ Subtask Name"
                            [(ngModel)]="data.NAME" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Description</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Task/ Subtask Description is Required">
                        <textarea nz-input [nzAutosize]="{ minRows: 2, maxRows: 6 }" name="taskSubtaskDescription"
                            placeHolder="Enter a Task/ Subtask Description" [(ngModel)]="data.DESCRIPTION"
                            required></textarea>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Hours</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Hours is Required">
                        <input nz-input name="estimatedHours" type="number" min="0" oninput="this.value = Math.abs(this.value)" placeHolder="Enter Hours" [(ngModel)]="data.ESTIMATED_HOURS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Minutes</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Minutes is Required">
                        <input nz-input name="estimatedMinutes" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Minutes" [(ngModel)]="data.ESTIMATED_MINUTES" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Seconds</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Seconds is Required">
                        <input nz-input name="estimatedSeconds" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.ESTIMATED_SECONDS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Assignee</nz-form-label>

                    <nz-form-control>
                        <nz-select name="assigneeName" nzShowSearch nzAllowClear nzPlaceHolder="Select Assignee Name" [(ngModel)]="data.ASSIGNEE_ID">
                            <nz-option *ngFor="let assignee of assigneeList" [nzValue]="assignee.ID" [nzLabel]="assignee.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Reporter</nz-form-label>

                    <nz-form-control>
                        <nz-select name="reporterName" nzShowSearch nzAllowClear nzPlaceHolder="Select Reporter Name" [(ngModel)]="data.REPORTER_ID">
                            <nz-option *ngFor="let reporter of reporterList" [nzValue]="reporter.ID" [nzLabel]="reporter.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Priority</nz-form-label>

                    <nz-form-control>
                        <nz-select name="priority" nzShowSearch nzAllowClear nzPlaceHolder="Select a Priority"
                            [(ngModel)]="data.PRIORITY">
                            <nz-option nzLabel="Critical" nzValue="C"></nz-option>
                            <nz-option nzLabel="Measure" nzValue="ME"></nz-option>
                            <nz-option nzLabel="Medium" nzValue="MD"></nz-option>
                            <nz-option nzLabel="Low" nzValue="L"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Time Tracked</nz-form-label>

                    <nz-form-control>
                        <nz-time-picker style="width: 100%;" name="timeTracked" [(ngModel)]="data.TIME_TRACKED"></nz-time-picker>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Status</nz-form-label>

                    <nz-form-control>
                        <nz-select name="status" nzShowSearch nzAllowClear nzPlaceHolder="Select a Status"
                            [(ngModel)]="data.STATUS">
                            <nz-option nzLabel="Pending" nzValue="P"></nz-option>
                            <nz-option nzLabel="Started" nzValue="S"></nz-option>
                            <nz-option nzLabel="Completed" nzValue="C"></nz-option>
                            <nz-option nzLabel="On Hold" nzValue="OH"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Start Date</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" nzFormat="dd/MM/yyyy" name="startDate"
                            (nzOnOpenChange)="handleStartOpenChange($event)" [(ngModel)]="data.START_DATE">
                        </nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>End Date</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker #endDatePicker style="width: 100%;" nzFormat="dd/MM/yyyy" name="endDate"
                            [(ngModel)]="data.END_DATE"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="4">
                <nz-form-item>
                    <nz-form-label nzNoColon>Is Child</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isChild" [(ngModel)]="data.IS_CHILD" (ngModelChange)="switchOnChange($event)"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="20">
                <nz-form-item>
                    <nz-form-label nzNoColon>Dependent Task</nz-form-label>

                    <nz-form-control>
                        <nz-select name="dependentTask" nzShowSearch nzAllowClear nzPlaceHolder="Select a Dependent Task" [(ngModel)]="data.DEPENDENT_TASK_ID" (ngModelChange)="selectOnChange($event)">
                            <nz-option *ngFor="let dependentTask of dependentTaskList" [nzValue]="dependentTask.ID" [nzLabel]="dependentTask.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="10">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Updated Date Time</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" name="updatedDate" nzShowTime [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="dd/MM/yyyy hh:mm a" [(ngModel)]="data.UPDATED_DATETIME"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <!-- <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Progress</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Progress is Required">
                        <input nz-input name="progress" type="number" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 100){this.value= 100}" min="0" max="100" placeHolder="Enter Progress between 0 To 100" [(ngModel)]="data.PROGRESS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>

    <!-- <div nz-col nzSpan="24">
        <nz-form-item>
            <nz-form-label nzNoColon>Tags</nz-form-label>
        </nz-form-item>

        <div>
            <nz-tag
                *ngFor="let tag of tags; let i = index"
                [nzMode]="'closeable'"
                (nzOnClose)="handleClose(tag)">
                    {{ sliceTagName(tag) }}
            </nz-tag>

            <nz-tag *ngIf="!inputVisible" class="editable-tag" nzNoAnimation (click)="showInput()">
                <i nz-icon nzType="plus"></i>New Tag
            </nz-tag>
        
            <input
                #inputElement
                nz-input
                nzSize="small"
                *ngIf="inputVisible"
                type="text"
                [(ngModel)]="inputValue"
                style="width: 78px;"
                (blur)="handleInputConfirm()"
                (keydown.enter)="handleInputConfirm()"/>
        </div>
    </div> -->
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(taskSbtaskPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false, taskSbtaskPage)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button nz-dropdown [nzDropdownMenu]="menu" *ngIf="!data.ID"
        (click)="save(false, taskSbtaskPage)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true, taskSbtaskPage)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="reset(taskSbtaskPage)"><span>Reset</span></button> -->
</div>